<template>
  <main class="login-page afro-bg">
    <section class="login-card paper-panel">
      <router-link class="login-brand" to="/menu" aria-label="Juliam Arcade">
        <span class="brand-mark">J</span>
        <span><b>JuLiam</b><strong>ARCADE</strong></span>
      </router-link>
      <p class="card-kicker">Player access</p>
      <h1>Iniciar sesión</h1>

      <form class="login-form" @submit.prevent="handleLogin">
        <label>
          <span class="afro-label">Correo o usuario</span>
          <input v-model.trim="email" class="afro-input" type="text" autocomplete="username" placeholder="tu@email.com" />
        </label>
        <label>
          <span class="afro-label">Contraseña</span>
          <input v-model="password" class="afro-input" type="password" autocomplete="current-password" placeholder="Tu contraseña" />
        </label>
        <button class="afro-btn primary-login" type="submit" :disabled="alreadyLoggingIn">
          {{ alreadyLoggingIn ? 'Entrando...' : 'Entrar a mi wallet' }}
        </button>
      </form>

      <p class="login-note">Consulta tus puntos, guarda tu QR y canjea recompensas dentro de Juliam Arcade.</p>

      <div class="login-actions">
        <router-link to="/registrarse" class="secondary-action">Registrarme</router-link>
        <router-link to="/menu" class="secondary-action">Ver menú</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'UserLogin',
  data() {
    return { email: '', password: '', alreadyLoggingIn: false }
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      if (this.alreadyLoggingIn) return
      if (!this.email || !this.password) return alert('Completa tu correo y contraseña')
      this.alreadyLoggingIn = true
      try {
        const response = await axios.post('/api/login_post', { email: this.email, password: this.password })
        if (response.data && response.data.success) {
          await this.login(response.data.user)
          this.$router.push('/wallet')
        } else {
          alert((response.data && response.data.error) || 'Usuario o contraseña incorrectos')
        }
      } catch (_error) {
        alert('Error en el servidor, intenta de nuevo mas tarde.')
      } finally {
        this.alreadyLoggingIn = false
      }
    }
  }
}
</script>

<style scoped>
.login-page { min-height: 100vh; display: grid; place-items: center; padding: clamp(16px, 4vw, 46px); }
.login-card { width: min(100%, 470px); padding: clamp(28px, 4vw, 40px); text-align: center; position: relative; overflow: hidden; z-index: 1; border-top: 2px solid var(--juliam-pink); }
.login-card::before { content: ''; position: absolute; inset: 0; pointer-events: none; background: radial-gradient(circle at 50% 0, rgba(141,114,255,.2), transparent 42%); }
.login-brand { display: inline-flex; align-items: center; gap: 12px; margin-bottom: 27px; color: var(--juliam-text); text-decoration: none; position: relative; }
.login-brand > span:last-child { display: grid; line-height: .82; text-align: left; }
.login-brand b { font-size: 18px; letter-spacing: -.04em; }
.login-brand strong { color: var(--juliam-cyan); font: 900 22px/1 var(--juliam-mono); letter-spacing: .1em; }
.brand-mark { width: 52px; height: 52px; display: grid; place-items: center; border: 2px solid var(--juliam-cyan); color: var(--juliam-pink); font: 900 29px/1 var(--juliam-mono); clip-path: polygon(10% 0, 100% 0, 100% 78%, 77% 100%, 0 100%, 0 12%); box-shadow: 0 0 18px rgba(76,245,255,.3); }
.card-kicker { margin: 0 0 8px; color: var(--juliam-lime); font: 900 10px/1 var(--juliam-mono); text-transform: uppercase; letter-spacing: .18em; position: relative; }
h1 { margin: 0 0 24px; color: var(--juliam-text); font-family: var(--juliam-sans); font-size: clamp(38px, 8vw, 52px); letter-spacing: -.055em; text-transform: uppercase; position: relative; }
.login-form { display: grid; gap: 14px; text-align: left; }
.primary-login { margin-top: 8px; width: 100%; min-height: 52px; }
.login-note { margin: 24px auto 16px; max-width: 360px; color: var(--juliam-muted); font-size: 13px; line-height: 1.55; }
.login-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.secondary-action { min-height: 46px; display: grid; place-items: center; border: 1px solid rgba(255,255,255,.14); border-radius: 10px; background: rgba(255,255,255,.025); color: var(--juliam-muted); font: 800 10px/1 var(--juliam-mono); letter-spacing: .08em; text-transform: uppercase; text-decoration: none; }
.secondary-action:hover { border-color: rgba(76,245,255,.45); color: var(--juliam-cyan); }
@media (max-width: 520px) { .login-page { padding: 14px; } .login-card { padding: 23px; } .login-actions { grid-template-columns: 1fr; } }
</style>
